import React from "react";
import {
  Avatar,
  Dialog,
  FlatButton,
  IconButton,
  IconMenu,
  List,
  ListItem,
  MenuItem,
  Paper,
  Subheader,
  Tab,
  Tabs
} from "material-ui";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import connectToStores from "alt-utils/lib/connectToStores";
import moment from "moment";

import VirtualContentStore from "../../stores/VirtualContentStore";
import VirtualContentActions from "../../actions/VirtualContentActions";
import { grey400, darkBlack } from "material-ui/styles/colors";

const formatTime = time => moment(time / 1000 / 1000).format("LLL");

class QueueList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      selectedItem: null
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal(item) {
    this.setState({ openModal: true, selectedItem: item });
  }

  handleCloseModal() {
    this.setState({ openModal: false, selectedItem: null });
  }

  render() {
    const { queue, submitAction, bannedMembers } = this.props;
    const { openModal, selectedItem } = this.state;

    const iconButtonElement = (
      <IconButton
        touch={true}
        tooltip="Actions"
        tooltipPosition="bottom-left"
        id="icon-menu-button"
        onClick={e => e.stopPropagation()}
      >
        <MoreVertIcon color={grey400} />
      </IconButton>
    );

    const rightIconButton = (item, isBanned) => {
      return (
        <IconMenu iconButtonElement={iconButtonElement} id="icon-menu">
          {!item.reviewed_at && (
            <MenuItem onClick={() => submitAction("mark_reviewed", item.id)}>
              Mark Reviewed
            </MenuItem>
          )}

          {!isBanned && (
            <MenuItem
              onClick={() =>
                submitAction("ban", item.id, {
                  ban: {
                    reason: "spam",
                    channel_ban_only: true
                  }
                })
              }
            >
              Channel Ban User
            </MenuItem>
          )}

          {isBanned && (
            <MenuItem
              onClick={() =>
                submitAction("unban", item.id, {
                  unban: {
                    channel_cid: item.message.cid
                  }
                })
              }
            >
              Unban User
            </MenuItem>
          )}

          {item.message.type !== "deleted" && (
            <MenuItem
              onClick={() =>
                submitAction("delete_message", item.id, {
                  delete_message: { hard_delete: false }
                })
              }
            >
              Delete Message
            </MenuItem>
          )}
          {item.message.type === "deleted" && (
            <MenuItem
              onClick={() => submitAction("restore", item.id, { restore: {} })}
            >
              Restore Message
            </MenuItem>
          )}
        </IconMenu>
      );
    };

    return (
      <div>
        <List style={{ height: 436, overflowY: "scroll" }}>
          {queue.map(item => {
            const isBanned = !!bannedMembers.find(
              m => m.user_id === item.entity_creator_id
            );

            return (
              <ListItem
                key={item.id}
                leftAvatar={<Avatar src={item.message.user.image} />}
                rightIconButton={rightIconButton(item, isBanned)}
                primaryText={
                  <div
                    style={{
                      textDecoration: isBanned ? "line-through" : "none"
                    }}
                  >
                    {item.message.user.name}
                  </div>
                }
                secondaryText={
                  <p>
                    {formatTime(
                      (item.message && item.message.created_at) ||
                        item.created_at
                    )}
                    <br />
                    {item.moderation_payload.texts &&
                      item.moderation_payload.texts.map((t, i) => (
                        <span
                          key={i}
                          style={{
                            color: darkBlack,
                            textDecoration:
                              item.message.type === "deleted"
                                ? "line-through"
                                : "none"
                          }}
                        >
                          {t}
                        </span>
                      ))}
                    {item.moderation_payload.images &&
                      item.moderation_payload.images.map((image, i) => (
                        <img key={i} src={image} style={{ height: "100px" }} />
                      ))}
                  </p>
                }
                secondaryTextLines={2}
                onClick={() => this.handleOpenModal(item)}
              />
            );
          })}

          {queue.length === 0 && <Subheader>No items in queue</Subheader>}
        </List>

        <Dialog
          title="Flagged Message"
          actions={[
            <FlatButton
              label="Close"
              primary={true}
              onClick={this.handleCloseModal}
            />
          ]}
          modal={false}
          open={openModal}
          onRequestClose={this.handleCloseModal}
          autoScrollBodyContent={true}
        >
          {selectedItem && (
            <div>
              <p>
                <b>User:</b> {selectedItem.message.user.name}
              </p>
              <p>
                <b>Flagged:</b> {formatTime(selectedItem.created_at)}
              </p>
              <p>
                <b>Sent:</b>{" "}
                {formatTime(
                  (selectedItem.message && selectedItem.message.created_at) ||
                    selectedItem.created_at
                )}
              </p>
              {selectedItem.moderation_payload.texts &&
                selectedItem.moderation_payload.texts.length > 0 && (
                  <p>
                    <b>Message:</b>{" "}
                  </p>
                )}
              {selectedItem.moderation_payload.texts &&
                selectedItem.moderation_payload.texts.map((t, i) => (
                  <p key={i}>{t}</p>
                ))}

              {selectedItem.moderation_payload.images &&
                selectedItem.moderation_payload.images.length > 0 && (
                  <p>
                    <b>Images:</b>{" "}
                  </p>
                )}
              {selectedItem.moderation_payload.images &&
                selectedItem.moderation_payload.images.map((image, i) => (
                  <a
                    key={i}
                    href={image}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={image}
                      style={{
                        "max-width": "300px",
                        width: "100%"
                      }}
                    />
                  </a>
                ))}
            </div>
          )}
        </Dialog>
      </div>
    );
  }
}

class ChatReviewQueue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.submitAction = this.submitAction.bind(this);
  }

  static getStores() {
    return [VirtualContentStore];
  }

  static getPropsFromStores() {
    return {
      reviewQueues: VirtualContentStore.getState().reviewQueues
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  fetchChatReviewQueue(film) {
    setTimeout(() => {
      VirtualContentActions.fetchChatReviewQueue({
        virtualContentId: film.virtual_content.id,
        options: {
          filters: {},
          sort: {
            created_at: -1
          },
          options: {}
        }
      });
    }, 0);
  }

  componentWillReceiveProps(props) {
    const { film } = props;

    if (film && !this.fetchChatReviewQueueInterval) {
      this.fetchChatReviewQueue(film);
      this.fetchChatReviewQueueInterval = setInterval(() => {
        this.fetchChatReviewQueue(film);
      }, 5000);
    }
  }

  componentWillUnmount() {
    if (this.fetchChatReviewQueueInterval) {
      clearInterval(this.fetchChatReviewQueueInterval);
    }
  }

  submitAction(actionType, itemId, options) {
    VirtualContentActions.submitChatReviewAction({
      virtualContentId: this.props.film.virtual_content.id,
      options: {
        actionType,
        itemId,
        options
      }
    });

    // wait a moment to refetch the queue
    setTimeout(() => {
      this.fetchChatReviewQueue(this.props.film);
    }, 200);
  }

  render() {
    if (!this.props.film) return <div></div>;

    const queue = this.props.reviewQueues[this.props.film.virtual_content.id];

    if (!queue) return <div></div>;

    let uniqueItems = [];
    const itemMap = new Map();

    queue.items.forEach(item => {
      const flaggerUserId = item.flags[0] && item.flags[0].user_id;
      const key = `mid:${item.message.id},fuid:${flaggerUserId}`;
      if (!itemMap.has(key)) {
        itemMap.set(key, true);
        uniqueItems.push(item);
      }
    });

    uniqueItems = uniqueItems.filter(i => i.message.user.role !== "admin");

    const queueInbox = uniqueItems.filter(i => !i.reviewed_at);
    const queueReviewed = uniqueItems.filter(i => i.reviewed_at);

    return (
      <Paper
        style={{
          width: "100%",
          borderRadius: "15px"
        }}
      >
        <h2 style={{ padding: "10px", paddingTop: "20px" }}>Moderation</h2>
        <Tabs>
          <Tab label="Inbox">
            <QueueList
              queue={queueInbox}
              submitAction={this.submitAction}
              bannedMembers={queue.bannedMembers}
            ></QueueList>
          </Tab>
          <Tab label="Reviewed">
            <QueueList
              queue={queueReviewed}
              submitAction={this.submitAction}
              bannedMembers={queue.bannedMembers}
            ></QueueList>
          </Tab>
        </Tabs>
      </Paper>
    );
  }
}

export default connectToStores(ChatReviewQueue);



// WEBPACK FOOTER //
// ./src/app/components/partials/chat-review-queue.jsx